(function () {
  'use strict';

  d3.chart('ChartBase', {
    initialize : function (options) {
      var plot = this;

      plot.options = options = options || {};

      // plot padding
      plot._padding = _.extend({
        top : 0,
        bottom : 0,
        left : 0,
        right : 0
      }, options.padding);

      // outer dimensions (including padding)
      plot._w = 0;
      plot._h = 0;

      // inner dimensions (excluding padding)
      plot.w = 0;
      plot.h = 0;

      plot.wrap = plot.base.append('g');

      if (plot.isRoot()) {
        // if this the root chart, set the svg to its OUTER size
        plot
            .on('change:width', function () {
              plot.base.attr('width', plot._w);
            })
            .on('change:height', function () {
              plot.base.attr('height', plot._h);
            });
      }
    },
    isRoot : function () {
      return this.base.node().nodeName.toLowerCase() === 'svg';
    },
    _update : function () {
      var plot = this;
      plot.w = plot._w - plot._padding.left - plot._padding.right;
      plot.h = plot._h - plot._padding.top - plot._padding.bottom;

      plot.wrap.translate(plot._padding.left, plot._padding.top);
    },
    width : function (w) {
      var plot = this;
      if (!arguments.length) return plot._w;

      plot._w = w;
      plot._update();

      plot.trigger('change:width');

      plot.redraw();

      return plot;
    },
    height : function (h) {
      var plot = this;
      if (!arguments.length) return plot._h;

      plot._h = h;
      plot._update();

      plot.trigger('change:height');
      plot.redraw();

      return plot;
    },
    padding : function (padding) {
      var plot = this;
      if (!arguments.length) return _.clone(plot._padding);

      if (typeof padding === 'number') {
        padding = {
          top : padding,
          bottom : padding,
          left : padding,
          right : padding
        };
      }

      _.extend(plot._padding, padding);
      plot._update();

      plot.trigger('change:padding');

      plot.redraw();

      return plot;
    },
    pad : function (side, value) {
      var plot = this;
      if (arguments.length < 2) return plot._padding[side];

      var p = {};
      p[side] = value;

      return plot.padding(p);
    },
    redraw : function () {
      this.redrawing = true;
      if (this.data) this.draw(this.data);
      this.redrawing = false;
    },
    // returns the root svg element surrounding this chart
    svg : function () {
      var base = this.base.node();
      // all svg elements have an ownerSVGElement -- except for an svg
      return d3.select(base.ownerSVGElement || base);
    },
    /**
     * Returns the existing (or creates a new) <defs> node in this svg.
     */
    defsNode : function () {
      var svg = this.svg();
      var defs = svg.select('defs');

      if (defs.empty()) {
        defs = svg.insert('defs');
      }

      return defs;
    },
    transform : function (data) {
      if (!this.redrawing) {
        this.trigger('change:data');
      }
      return data;
    }
  });

})();
